import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Asset, Entry } from 'contentful';
import { TypeScriptValidations } from '../_models/typescript-validations';

@Injectable({
  providedIn: 'root'
})
export class TypescriptValidationsService {

  constructor() { }

  private typeScriptValidations$ = new BehaviorSubject<any>(null);
  public typeScriptValidations: Observable<any> = this.typeScriptValidations$.asObservable();

  saveCachedFormBrandSettings(value:Array<Entry<TypeScriptValidations>>) {
    this.typeScriptValidations$.next(value) 
  }

  getCachedFormBrandSettings(): Array<Entry<TypeScriptValidations>> {
    return this.typeScriptValidations$.getValue();
  }

  processStringFuncion(funcionStr: string, params: Object) {
    try {
      const dynamicFunction = this.crearFuncionDesdeString(funcionStr);
      const result = dynamicFunction(params);      
      return result;
    } catch (e) {
      console.error('Error:', e);
    }
  }

  private parseFunctionString(funcStr: string): { params: string[], body: string } {
    // Regular expression to capture:
      // - Function name (optional)
      // - Parameters inside parentheses
      // - Body in braces
    const regex = /function\s*\w*\s*\(([^)]*)\)\s*\{([\s\S]*)\}/;
    const match = funcStr.match(regex);

    if (!match) {
      throw new Error('The string is not in the expected function format');
    }

    // match[1] contains the list of parameters (ex: "Key1Val, Key2Val")
    // match[2] contains the function body
    const paramsString = match[1].trim();
    const body = match[2];

    // Process parameters: separate by commas, remove spaces and filter voids
    let params: string[] = [];
    if (paramsString) {
      params = paramsString.split(',').map(p => p.trim()).filter(p => p.length > 0);
    }

    return { params, body };
  }

  private crearFuncionDesdeString(funcStr: string): Function {
    const { params, body } = this.parseFunctionString(funcStr);
    return new Function(...params, body);
  }




}
